import { useEffect, useState } from "react"
import { doQuery } from "@/client/utils/useQuery"
import OutTableColumn from '@client/models/outTableColumn';
import project from '@client/stores/projectStore'

const outTableColumn = new OutTableColumn()

export default function useOutTemplateData(tab: any) {
    const [data, setData] = useState<any>(false)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<any>(false)
    const args = { params: [project.currentProject.value?._id, tab?.store?.data?.id, { mapping: true }] }
    // const args = {
    //     project: project.currentProject.value?._id,
    //     page: 1,
    //     count: 200
    // }

    useEffect(() => {
        const _waitForData = async () => {
            try {
                const res = await doQuery(outTableColumn.read, args, false, 0) as any
                setData(res?.data || [])
                setLoading(false)
            }
            catch (err: any) {
                if (err.response) {
                    console.log('data:', err.response.data)
                    console.log('status:', err.response.status)
                    console.log('headers:', err.response.headers)
                }
                else {
                    console.log('Error:', err.message)
                }
                setError(err)
            }
            return () => {
                setLoading(false)
            }
        }
        if (tab?.store?.formData) {
            setData(tab.store?.formData)
            setLoading(false)
        }
        else if (tab?.store?.data?.id) _waitForData()
    }, [tab?.store?.data?.id])

    return { data, loading, error }
}